"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const output_buffering_1 = require("../output-buffering");
const is_traversable_1 = require("./is-traversable");
const iterator_to_hash_1 = require("./iterator-to-hash");
const count_1 = require("./count");
/**
 * Adapted from https://github.com/kvz/locutus/blob/master/src/php/var/var_dump.js
 */
function varDump(...args) {
    let padChar = ' ';
    let padVal = 4;
    let lgth = 0;
    let getInnerVal = function _getInnerVal(val) {
        let result = '';
        if (val === null || typeof val === 'undefined') {
            result = 'NULL';
        }
        else if (typeof val === 'boolean') {
            result = 'bool(' + val + ')';
        }
        else if (typeof val === 'number') {
            if (parseFloat('' + val) === parseInt('' + val, 10)) {
                result = 'int(' + val + ')';
            }
            else {
                result = 'float(' + val + ')';
            }
        }
        else if (typeof val === 'function') {
            result = 'object(Closure) (0) {}';
        }
        else {
            result = 'string(' + val.length + ') "' + val + '"';
        }
        return result;
    };
    let formatArray = function _formatArray(obj, curDepth, padVal, padChar) {
        if (is_traversable_1.isTraversable(obj)) {
            obj = iterator_to_hash_1.iteratorToHash(obj);
        }
        if (curDepth > 0) {
            curDepth++;
        }
        let baseCount = padVal * (curDepth - 1);
        let thickCount = padVal * (curDepth + 1);
        let basePad = padChar.repeat(baseCount > 0 ? baseCount : 0);
        let thickPad = padChar.repeat(thickCount);
        let str = '';
        let val;
        if (typeof obj === 'object' && obj !== null) {
            lgth = count_1.count(obj);
            str += 'array(' + lgth + ') {\n';
            for (let key in obj) {
                let objVal = obj[key];
                if ((typeof objVal === 'object') && (objVal !== null) && !(objVal instanceof Date)) {
                    str += thickPad;
                    str += '[';
                    str += key;
                    str += '] =>\n';
                    str += thickPad;
                    str += formatArray(objVal, curDepth + 1, padVal, padChar);
                }
                else {
                    val = getInnerVal(objVal);
                    str += thickPad;
                    str += '[';
                    str += key;
                    str += '] =>\n';
                    str += thickPad;
                    str += val;
                    str += '\n';
                }
            }
            str += basePad + '}\n';
        }
        else {
            str = getInnerVal(obj) + '\n';
        }
        return str;
    };
    let output = [];
    for (let arg of args) {
        output.push(formatArray(arg, 0, padVal, padChar));
    }
    output_buffering_1.echo(output.join(''));
}
exports.varDump = varDump;
